/* eslint-disable arrow-body-style */
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {catchError, exhaustMap, map, of, switchMap, withLatestFrom} from "rxjs";
import {AiAssistantActions} from "../shared.actions";
import {AiAssistantService} from "../../services/ai-assistant/ai-assistant.service";
import {Store} from "@ngrx/store";
import {selectAiAssistantThreadId} from "./ai-assistant.selectors";
import {ErrorHandlingUtil} from "../../utils/error-handling-util";

export const aiAssistantConversationStart = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions), aiAssistantService = inject(AiAssistantService)) => {
        return actions$.pipe(
            ofType(AiAssistantActions.conversationStart),
            withLatestFrom(store$.select(selectAiAssistantThreadId)),
            exhaustMap(([action, threadId]) =>
                (threadId) ? of(AiAssistantActions.conversationAlreadyExists()) :
                    aiAssistantService.startConversation().pipe(
                        map((newThreadId) => AiAssistantActions.conversationStartSuccess({threadId: newThreadId})),
                        catchError((errorResponse: any) => of(AiAssistantActions.conversationStartError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)})))
                    )
            )
        );
    },
    {functional: true}
);

export const aiAssistantMessageSend = createEffect(
    (store$ = inject(Store), actions$ = inject(Actions), aiAssistantService = inject(AiAssistantService)) => {
        return actions$.pipe(
            ofType(AiAssistantActions.messageSend),
            withLatestFrom(store$.select(selectAiAssistantThreadId)),
            exhaustMap(([action, threadId]) =>
                (threadId)
                    ? aiAssistantService.sendMessage(threadId, {userMessage: action.userMessage}).pipe(
                        map((messages) => AiAssistantActions.messageResponse({messages})),
                        catchError((errorResponse: any) => of(AiAssistantActions.messageSendError({errorMsg: ErrorHandlingUtil.getErrorMessage(errorResponse)}))))
                    : of(AiAssistantActions.messageSendError({errorMsg: "no current ai assistant thread found - please refresh the page"}))
            )
        );
    },
    {functional: true}
);

export const uploadFileAndRefreshFiles$ = createEffect(
    (actions$ = inject(Actions), aiService = inject(AiAssistantService)) => {
        return actions$.pipe(
            ofType(AiAssistantActions.uploadFileSuccess),
            switchMap(({ threadId }) =>
                aiService.listFiles(threadId).pipe(
                    map(files => AiAssistantActions.loadFilesSuccess({ files })),
                    catchError(err =>
                        of(AiAssistantActions.loadFilesError({errorMsg: ErrorHandlingUtil.getErrorMessage(err)}))
                    )
                )
            )
        );
    },
    { functional: true }
);

